import Modal from '@/components/ui/Modal';
import Botao from '@/components/ui/Botao';

interface Props {
  aberto: boolean;
  apelido: string;
  testando: boolean;
  aoFechar: () => void;
  aoTestar: () => void;
}

// Folha com o passo a passo da maquininha, com a linguagem do organizador.
export default function FolhaInstrucaoPoint({
  aberto,
  apelido,
  testando,
  aoFechar,
  aoTestar,
}: Props) {
  return (
    <Modal
      aberto={aberto}
      titulo="Ligar a maquininha ao sistema"
      aoFechar={aoFechar}
      rodape={
        <div className="space-y-2">
          <Botao
            variante="primario"
            tamanho="lg"
            cheio
            icone="ri-printer-line"
            carregando={testando}
            onClick={aoTestar}
          >
            {testando ? 'Imprimindo…' : 'Testar impressão'}
          </Botao>
          {testando && (
            <p className="text-center text-[14px] text-foreground-500">Olhe a maquininha.</p>
          )}
          <Botao variante="secundario" tamanho="md" cheio onClick={aoFechar}>
            Fechar
          </Botao>
        </div>
      }
    >
      <div className="flex items-center justify-center gap-3 rounded-2xl bg-primary-50 py-5">
        <span className="flex h-14 w-14 items-center justify-center rounded-2xl bg-white text-primary-600">
          <i className="ri-smartphone-line text-3xl" />
        </span>
        <span className="flex h-6 w-6 items-center justify-center text-foreground-300">
          <i className="ri-arrow-right-line text-xl" />
        </span>
        <span className="flex h-14 w-14 items-center justify-center rounded-2xl bg-white text-primary-600">
          <i className="ri-printer-line text-3xl" />
        </span>
      </div>

      <p className="mt-5 text-[16px] font-semibold text-foreground-950">Agora, na maquininha:</p>
      <ol className="mt-3 space-y-3 text-[15px] leading-relaxed text-foreground-700">
        <li className="flex gap-3">
          <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-primary-100 text-[13px] font-bold text-primary-700">
            1
          </span>
          Desligue e ligue de novo.
        </li>
        <li className="flex gap-3">
          <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-primary-100 text-[13px] font-bold text-primary-700">
            2
          </span>
          <span>
            Toque em <strong className="font-semibold">“Vendas vinculadas”</strong>.
          </span>
        </li>
        <li className="flex gap-3">
          <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-primary-100 text-[13px] font-bold text-primary-700">
            3
          </span>
          <span>
            Deixe a maquininha nessa tela. Ela mostra:{' '}
            <em className="not-italic text-foreground-600">
              “Inicie a operação pelo sistema de frente de caixa”.
            </em>
          </span>
        </li>
      </ol>

      <p className="mt-4 rounded-2xl bg-background-100 px-4 py-3 text-[14px] text-foreground-600">
        Quando a maquininha estiver nessa tela, toque em{' '}
        <strong className="font-semibold">Testar impressão</strong> aqui em cima.
        {apelido ? ` (${apelido})` : ''}
      </p>
    </Modal>
  );
}